export default "/profile/images/instruction-2-ua.webp?750c570a54332a3bb9ff8b34842f86e3";